import type { PersonalityTrait } from 'generated/openapi';
import { type HTMLAttributes, memo } from 'react';

import { PERSONALITY_TRAIT_MAP } from '@/features/profile/utils/personalityTrait';
import { Badge } from '@/shared/components/ui/badge';
import { Card } from '@/shared/components/ui/card';

export interface ProfileDetailsVibeDuoPersonalityProps extends HTMLAttributes<HTMLDivElement> {
  personalityTraits?: PersonalityTrait[];
}

export const ProfileDetailsVibeDuoPersonality = memo(
  function ProfileDetailsVibeDuoPersonality({
    personalityTraits,
    ...props
  }: ProfileDetailsVibeDuoPersonalityProps) {
    if (!personalityTraits?.length) return null;

    return (
      <Card variant="data" {...props}>
        <p className="text-sm leading-5 font-bold">Duo personality</p>
        <div className="flex flex-wrap gap-2">
          {personalityTraits.map(trait => {
            const option = PERSONALITY_TRAIT_MAP.get(trait);
            if (!option) return null;
            return (
              <Badge key={trait} variant="display">
                {option.label}
              </Badge>
            );
          })}
        </div>
      </Card>
    );
  },
);
